export default [
  {
    perfil: 'Administrador',
    roles: [
      {
        rol: 'Administración',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Configuración',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Contratos',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Supervisión',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Estimaciones',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Catálogos',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Seguridad',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
    ],
  },

  {
    perfil: 'Cliente',
    roles: [
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },

  {
    perfil: 'Contratista',
    roles: [
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },

  {
    perfil: 'Responsable',
    roles: [
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },

];
